import { Select } from "@chakra-ui/react";
import React, { useState } from "react";
import BraceletsSizeDialog from "./BraceletsSizeDialog";

// Size chart data
const sizeChartData = [
  { womenLabel: "X-Small (XS)", menLabel: "N/A", unisexLabel: "X-Small (XS) (Women)" },
  { womenLabel: "Small (S) (Fit Most Women)", menLabel: "N/A", unisexLabel: "Small (S) (Fit Most Women)" },
  { womenLabel: "Medium (M)", menLabel: "N/A", unisexLabel: "Medium (M) (Women)" },
  { womenLabel: "Large (L)", menLabel: "Small (S)", unisexLabel: "Large (L) (Women)" },
  { womenLabel: "X-Large (XL)", menLabel: "Medium (M) (Fit Most Men)", unisexLabel: "X-Large (XL) (Women)" },
  { womenLabel: "2X-Large (2XL)", menLabel: "Large (L)", unisexLabel: "2X-Large (2XL) (Women)" },
  { womenLabel: "3X-Large (3XL)", menLabel: "X-Large (XL)", unisexLabel: "3X-Large (3XL) (Women)" },
  { womenLabel: "N/A", menLabel: "2X-Large (2XL)", unisexLabel: "Small (S) (Men)" },
  { womenLabel: "N/A", menLabel: "3X-Large (3XL)", unisexLabel: "Medium (M) (Fit Most Men)" },
  { womenLabel: "N/A", menLabel: "N/A", unisexLabel: "Large (L) (Men)" },
  { womenLabel: "N/A", menLabel: "N/A", unisexLabel: "X-Large (XL) (Men)" },
  { womenLabel: "N/A", menLabel: "N/A", unisexLabel: "2X-Large (2XL) (Men)" },
  { womenLabel: "N/A", menLabel: "N/A", unisexLabel: "3X-Large (3XL) (Men)" },
];

const BraceletSizeSelector = ({
  selectedProduct,
  selectedBraceletSizeMen,
  setSelectedBraceletSizeMen,
  selectedBraceletSizeWomen,
  setSelectedBraceletSizeWomen,
}) => {
  const [isBraceletSize, setIsBraceletSize] = useState(false);

  const isForCouples = selectedProduct?.subcategories?.some(
    (subcat) => subcat.name === "FOR COUPLES"
  );

  const gender = selectedProduct?.gender;

  const menOptions = sizeChartData
    .map((item) => item.menLabel)
    .filter((label) => label !== "N/A")
    .filter((label, idx, arr) => arr.indexOf(label) === idx); // remove duplicates

  const womenOptions = sizeChartData
    .map((item) => item.womenLabel)
    .filter((label) => label !== "N/A")
    .filter((label, idx, arr) => arr.indexOf(label) === idx); // remove duplicates

  const unisexOptions = sizeChartData
    .map((item) => item.unisexLabel)
    .filter((label) => label !== "N/A")
    .filter((label, idx, arr) => arr.indexOf(label) === idx); // remove duplicates


  return (
    <div className="pb-3">
      <div className="flex items-center gap-2 mb-2">
        <label htmlFor="sizeSelect">Bracelet Size:</label>
        <div
          className="underline cursor-pointer text-sm text-[#000080]"
          onClick={() => setIsBraceletSize(true)}
        >
          Size Chart
        </div>
      </div>

      {isForCouples ? (
        <div className="flex w-full gap-6">
          <div>
            <label htmlFor="menSizeSelect">Men Size</label>
            <Select
              id="menSizeSelect"
              border="1px solid"
              _hover="none"
              className="px-4 pt-0 mt-2"
              width="45"
              borderColor="#000080"
              value={selectedBraceletSizeMen}
              onChange={(e) => setSelectedBraceletSizeMen(e.target.value)}
              required
            >
              <option value="">Select Men Size</option>
              {menOptions.map((label) => (
                <option key={label} value={label}>
                  {label}
                </option>
              ))}
            </Select>
          </div>
          <div>
            <label htmlFor="womenSizeSelect">Women Size</label>
            <Select
              id="womenSizeSelect"
              border="1px solid"
              _hover="none"
              className="px-4 pt-0 mt-2"
              width="45"
              borderColor="#000080"
              value={selectedBraceletSizeWomen}
              onChange={(e) => setSelectedBraceletSizeWomen(e.target.value)}
              required
            >
              <option value="">Select Women Size</option>
              {womenOptions.map((label) => (
                <option key={label} value={label}>
                  {label}
                </option>
              ))}
            </Select>
          </div>
        </div>
      ) : (
        <Select
          id="sizeSelect"
          border="1px solid"
          _hover="none"
          className="px-4 pt-0"
          width="40"
          borderColor="#000080"
          value={gender === "male" ? selectedBraceletSizeMen : selectedBraceletSizeWomen}
          onChange={(e) => {
            if (gender === "male") {
              setSelectedBraceletSizeMen(e.target.value);
            } else {
              setSelectedBraceletSizeWomen(e.target.value);
            }
          }}
          required
        >
          <option value="">Select Size</option>
          {(gender === "male" ? menOptions : gender === "unisex"
            ? unisexOptions
            : womenOptions).map((label) => (
              <option key={label} value={label}>
                {label}
              </option>
            ))}
        </Select>
      )}

      <BraceletsSizeDialog isOpen={isBraceletSize} onClose={() => setIsBraceletSize(false)} />
    </div>
  );
};

export default BraceletSizeSelector;
